<div class="statStandingsTable" >
    <p class="statText">{{data.stat}}</p>
    <table class='standingsTable'>
        <tr *ngFor="let team of data.standings; let i = index;">
            <app-stat-standings-row [rank]="(i + 1)" [logo]="team.teamLogo" [name]="team.teamName" [value]="team.teamValue"></app-stat-standings-row>
        </tr>
    </table>
</div>